// Renders a loading spinner, or an error state with a one-tap Retry, or the
// children once data is ready. Pair with useDbValue: <DataGate {...res}>…</DataGate>.
// `dark` styles it for dark-green backgrounds.
export default function DataGate({ status, error, retry, children, label = 'Loading…', dark = false }) {
  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center gap-3 py-8" role="status" aria-live="polite">
        <span
          className="inline-block w-4 h-4 rounded-full animate-spin"
          style={{ border: '2px solid #123D26', borderTopColor: 'transparent' }}
          aria-hidden="true"
        />
        <span className={`text-sm ${dark ? 'text-white/80' : 'text-gray-500'}`}>{label}</span>
      </div>
    )
  }
  if (status === 'error') {
    return (
      <div
        className="rounded-xl p-5 text-center"
        style={dark
          ? { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)' }
          : { background: '#F8FAF9', border: '1px solid rgba(0,0,0,0.08)' }}
        role="alert">
        <p className={`text-sm font-bold ${dark ? 'text-white' : 'text-gray-800'}`}>
          Couldn't load — connection problem.
        </p>
        <p className={`text-sm mt-1 ${dark ? 'text-white/70' : 'text-gray-500'}`}>
          {error?.message || 'Please check your connection and try again.'}
        </p>
        <button
          type="button"
          onClick={retry}
          className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-md font-bold text-sm text-white transition active:scale-[0.98]"
          style={{ background: '#123D26' }}>
          <span aria-hidden="true">↻</span> Retry
        </button>
      </div>
    )
  }
  return children
}
